<wiz-vgroup width="100%" height="100%" gap="2" class="section-container">
  <!-- filtre de la popUp -->
  <wiz-hgroup width="100%" [visible]="!remoteMode">
    <filter-component #popFilter width="100%"> </filter-component>
  </wiz-hgroup>
  
  <wiz-hgroup #gpOperator width="100%" [visible]="showComparator" verticalAlign="end">
    <wiz-dropdown
    #ddlComparator
    [wizDataProvider]="comparatorDS"
    [wizLabelField]="'fulltrsLabel'"
    [wizLabel]="'$.filter.comparator.$'"
    width="100px"
    wizPanelWidth="200px"></wiz-dropdown>
    
  <wiz-text-input
    #ti visible="false"
    [wizLabel]="'$.filter.expression.$'"
    width="100%"></wiz-text-input>
  <wiz-numeric-input
    #ni visible="false"
    [wizMaxChars]="20"
    width="100%"
    nbDecimal="3"></wiz-numeric-input>
  <wiz-datefield #da visible="false"  width="100%"></wiz-datefield>
  <wiz-checkbox #cb visible="false" wizShowLabel="false" ></wiz-checkbox>

  <wiz-numeric-input
    #ni2 visible="false"
    [wizMaxChars]="20"
    width="100%"
    nbDecimal="3"></wiz-numeric-input>
  <wiz-datefield #da2 visible="false" width="100%"></wiz-datefield>


  <wiz-icon
    [visible]="hasExp()"
    style="cursor: pointer; font-size: 20px;padding-bottom: 5px;"
    (click)="clearExp()"
    [wizTooltip]="'$.common.delete.$'">delete</wiz-icon>
  </wiz-hgroup>

  <wiz-hgroup width="100%" height="100%" [visible]="!remoteMode">
    <wiz-ag-grid
    #agGrid 
    width="100%"
    height="100%"
    class="ag-theme-alpine"
    [widget]="widget"
    [columnDefs]="columns"
    [wizDatasource]="lineDS"
    [wizRowSelection]="'multiple'"
    [style.display]="gridDisplayMode"
    ></wiz-ag-grid>
  </wiz-hgroup>
    
  <!-- <wiz-hgroup width="100%" height="100%" verticalAlign="center" horizontalAlign="center" [visible]="remoteMode">
    <wiz-label [wizLabel]="'$.unavailable.remote.$'" class="componentLabel"></wiz-label>
  </wiz-hgroup> -->


  <wiz-hgroup width="100%" horizontalAlign="space-between">
    <wiz-button
      #btnCancel
      class="cancel-button"
      [wizIcon]="'arrow-left'"
      (wizClick)="doCancel()"
      [wizLabel]="'$.common.cancel.$'"
    ></wiz-button>
    <wiz-button
      #btnSave
      [wizLabel]="'$.common.ok.$'"
      [wizIcon]="'arrow-right'"
      [iconPlacement]="'right'"
      (wizClick)="save()"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
